import { getRelativeTime } from '@shared/utils/timeUtils';
import { getFormattedTitle } from '@shared/utils/eventUtils';

export const momentTileProps = (moment) => {
	return {
		id:              moment.id,
		backgroundImage: moment.imageUrl || null,
		expiresAt:       moment.expiresAt ? getRelativeTime(new Date(moment.expiresAt).getTime() / 1000, { untilHour: 1000, useRemainingHoursDays: true }) : null,
		isCommunityCrop: moment.isCommunityCrop,
		name:            moment.event ? getFormattedTitle(moment.event, { noLineBreaksForTeamNames: true }) : null,
		isBookmarked:    moment.expiresAt === null,
		canDelete:       moment.can?.delete ?? false,
		canUpdate:       moment.can?.update ?? false,
	};
};
